import { FormHelperText } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import ConfirmButton, {
  ConfirmButtonTransitionState
} from "@saleor/components/ConfirmButton";
import Form from "@saleor/components/Form";
import FormSpacer from "@saleor/components/FormSpacer";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { ServerErrorFragment } from "@saleor/fragments/types/ServerErrorFragment";
import { buttonMessages } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { PayableStatusEnum } from "@saleor/types/globalTypes";
import { getFormErrors } from "@saleor/utils/errors";
import getPayoutMessage from "@saleor/utils/errors/payout";
import {
  hasNoError,
  payableStatusValidation
} from "@saleor/utils/validators/payoutSettlement";
import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { PayoutStoreOrderDetails_payoutStoreOrder } from "../../types/PayoutStoreOrderDetails";

export interface PaybleStatusDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: any;
  confirmButtonState: ConfirmButtonTransitionState;
  errors: ServerErrorFragment[];
  FinanceStoreOrderDetails: PayoutStoreOrderDetails_payoutStoreOrder;
}

export interface PayableFormData {
  payableStatus: string;
}

export interface PayableFormValidation {
  payableStatus: string;
}

const useStyles = makeStyles(
  () => ({
    buttonActionFlex: {
      flexDirection: "column"
    },
    buttonActions: {
      display: "flex",
      width: "100%"
    },
    buttonWidth: {
      margin: "3px",
      width: "100%"
    },
    errorText: {
      color: "#EC5D77",
      fontSize: "0.75rem",
      margin: "6px 14px"
    },
    singleSelectField: {
      "& label": {
        overflowX: "visible",
        width: "100%"
      }
    },
    textBold: {
      "&:nth-child(1)": {
        marginTop: "0px"
      },
      fontSize: "14px",
      fontWeight: 600,
      margin: "12px 0px"
    }
  }),
  { name: "PaybleStatusDialog" }
);

const PaybleStatusDialog: React.SFC<PaybleStatusDialogProps> = props => {
  const {
    onClose,
    open,
    onSubmit,
    FinanceStoreOrderDetails,
    confirmButtonState,
    errors
  } = props;

  const classes = useStyles(props);
  const intl = useIntl();
  const container = React.useRef<HTMLDivElement>();
  const disabled = FinanceStoreOrderDetails ? false : true;

  const initialForm: PayableFormData = {
    payableStatus: maybe(() => FinanceStoreOrderDetails.payable_status, null)
  };

  const payableStatusChoices = [
    { label: "Paid", value: PayableStatusEnum.PAID },
    { label: "Rejected", value: PayableStatusEnum.REJECTED }
  ];

  const formFields = ["payableStatus"];

  const formErrors = getFormErrors(formFields, errors);

  const initalFormValidation: PayableFormValidation = {
    payableStatus: null
  };
  const [clientError, setErrorValdiation] = useState(initalFormValidation);

  const handleSubmit = (event: any) => {
    const validate = payableStatusValidation(event);
    if (hasNoError(validate)) {
      setErrorValdiation(validate);
      onSubmit(event);
    } else {
      setErrorValdiation(validate);
    }
  };

  return (
    <Form initial={initialForm} onSubmit={handleSubmit} confirmLeave>
      {({ data: formData, change, submit }) => (
        <Dialog onClose={onClose} open={open} maxWidth="xs" fullWidth>
          <>
            <DialogContent ref={container}>
              <FormSpacer />
              <SingleSelectField
                choices={payableStatusChoices}
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Payable List Status"
                })}
                name="payableStatus"
                onChange={change}
                value={formData.payableStatus}
              />
              {formErrors?.payableStatus ? (
                <FormHelperText className={classes.errorText}>
                  {getPayoutMessage(formErrors.payableStatus, intl)}
                </FormHelperText>
              ) : clientError?.payableStatus ? (
                <FormHelperText className={classes.errorText}>
                  {clientError?.payableStatus}
                </FormHelperText>
              ) : null}
              <FormSpacer />
            </DialogContent>
            <DialogActions className={classes.buttonActionFlex}>
              <div className={classes.buttonActions}>
                <Button onClick={onClose} className={classes.buttonWidth}>
                  <FormattedMessage {...buttonMessages.back} />
                </Button>
                <ConfirmButton
                  transitionState={confirmButtonState}
                  color="primary"
                  variant="contained"
                  type="submit"
                  onClick={submit}
                  className={classes.buttonWidth}
                >
                  <FormattedMessage
                    defaultMessage="SAVE"
                    description="button"
                  />
                </ConfirmButton>
              </div>
            </DialogActions>
          </>
        </Dialog>
      )}
    </Form>
  );
};
PaybleStatusDialog.displayName = "PaybleStatusDialog";
export default PaybleStatusDialog;
